import React, { useEffect } from 'react';
import { Modal } from '@getro/rombo';
import { Box, Link, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';

import { trackEvent } from '../../../helpers/analytics';
import { HubspotEmbed } from '../hubspotEmbed';

export const HubspotMeetingsModal = ({ kind, onCancel }) => {
  const strings = {
    contacts: {
      title: 'Upgrade to unleash your full network potential',
      description:
        'You’ve reached your contact limit. Schedule a call with our team to explore your options and ensure you never a miss high-impact intro.',
    },
    companies: {
      title: 'Upgrade to add more companies to your job board',
      description:
        'Schedule a quick call with our team to explore your options and ensure every company in your network gets the visibility it deserves.',
    },
  };

  useEffect(() => {
    trackEvent('upsell:paywall_shown', { origin: `add_${kind}` });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal variant="large" onCancel={onCancel}>
      <Box as="header">
        <Text fontSize="24px" fontWeight="semibold" color="text.dark">
          {strings[kind].title}
        </Text>
        <Text mt="8px" fontSize="18px">
          {strings[kind].description}
        </Text>
        <Text mt="12px" fontSize="18px">
          If you prefer, email us at{' '}
          <Link
            href="mailto:success@getro.com"
            sx={{
              color: 'text.main',
              textDecoration: 'none',
              ':hover': {
                textDecoration: 'underline',
              },
            }}
          >
            success@getro.com
          </Link>
          .
        </Text>
      </Box>
      <Box mt="16px" height="680px" width="750px">
        <HubspotEmbed />
      </Box>
    </Modal>
  );
};

HubspotMeetingsModal.propTypes = {
  kind: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
};

HubspotMeetingsModal.defaultProps = {
  kind: 'contacts',
};
